import React, { Fragment, Component } from 'react';
import {
    Datagrid,
    Filter,
    List,
    NumberField,
    NumberInput,
//    ReferenceInput,
    SelectInput,
    TextField,
//    TextInput,
} from 'react-admin';

import { connect } from 'react-redux';
import { push } from 'react-router-redux';

import Icon from '@material-ui/icons/Bookmark';
export const ConfigIcon = Icon;


export const CbrEstimateFilter = props => (
    <Filter {...props}>
        <SelectInput source="Codec" alwaysOn choices={[
            { id: 'MPEG2', name: 'MPEG2' },
            { id: 'AVC', name: 'AVC' },
            { id: 'HEVC', name: 'HEVC' },
        ]} />
        <SelectInput source="InputFormat" alwaysOn choices={[
            { id: '480i', name: '480i' },
            { id: '576i', name: '576i' },
            { id: '720p50', name: '720p50' },
            { id: '720p60', name: '720p60' },
            { id: '1080i25', name: '1080i25' },
            { id: '1080i30', name: '1080i30' },
            { id: '1080p50', name: '1080p50' },
            { id: '1080p60', name: '1080p60' },
            { id: '2160p50', name: '2160p50' },
            { id: '2160p60', name: '2160p60' },
        ]} />
        <SelectInput source="Resolution" alwaysOn choices={[
            { id: 'Follow Input', name: 'Follow Input' },
            { id: '1440x1080', name: '1440x1080' },
            { id: 'SD', name: 'SD' },
        ]} />
        <NumberInput label="EsRate [Kbps]" source="Esrate" inputProps={{step:50, min: 1000}} alwaysOn />
        <SelectInput source="Cpu" alwaysOn choices={[
            { id: 'E-2136', name: 'E-2136' },
            { id: 'SILVER-4110', name: 'SILVER-4110' },
            { id: 'SILVER-4210', name: 'SILVER-4210' },
            { id: 'GOLD-5118', name: 'GOLD-5118' },
            { id: 'GOLD-5218', name: 'GOLD-5218' },
            { id: 'GOLD-6140', name: 'GOLD-6140' },
            { id: 'GOLD-6240', name: 'GOLD-6240' },
            { id: 'GOLD-6154', name: 'GOLD-6154' },
            { id: 'GOLD-6254', name: 'GOLD-6254' },
            { id: 'EPYC-7702P', name: 'EPYC-7702P' },
        ]} />
        <SelectInput source="Virtualization" alwaysOn choices={[
            { id: 'BM', name: 'BM' },
            { id: 'Kubernetes_on_BM', name: 'Kubernetes_on_BM' },
            { id: 'VM', name: 'VM' },
        ]} />
    </Filter>
);

class CbrEstimateList extends Component {
    render() {
        const props = this.props;
        return (
            <Fragment>
                <List title={<ConfigTitle />}  {...props}
                      filters={<CbrEstimateFilter />}
                      bulkActionButtons={false}
                      sort={{ field: 'Density', order: 'DESC' }}
                      exporter={false}
                >
                    <Datagrid rowClick="show">
                        <NumberField label="EsRate [Kbps]" source={"Esrate"} />
                        <TextField label="Cpu" source={"Cpu"} />
                        <TextField label="Virtualization" source={"Virtualization"} />
                        <NumberField label="Density" source={"Density"} />
                    </Datagrid>
                </List>
            </Fragment>
        );
    }
}



const ConfigTitle = ({ record }) => {
    return <span style={{ marginLeft: 16}}>CBR Estimates</span>;
};


export default connect(
    undefined,
    { push }
)(CbrEstimateList);